import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { Reservation } from '../types/reservation'
import { LocationKey, LocationsKey } from '../types/location'

/**
 * オンライン日程選択ページで使われるリダイレクト処理
 */
export const useRedirectToReschedule = (
  reservation: Reservation | null,
  path: 'multicreator' | 'trial_lessons' = 'trial_lessons'
) => {
  const router = useRouter()

  useEffect(() => {
    if (!reservation) return

    const currentParams = window.location.search
    // オンライン日程選択 -> オンライン振替ページへ
    let redirectUrl = `/${path}/${reservation.id}/reschedule${currentParams}`

    // 拠点の有効予約を持っている状態でオンライン日程選択 -> 有効予約を持っている拠点振替ページへ
    // オンラインの場合locationが `null` になる模様なのでoptional chainingを使用
    const key = reservation.reservable.location?.key
    if (key && Object.values(LocationKey).includes(key)) {
      redirectUrl = `/${path}/locations/${key}/${reservation.id}/reschedule${currentParams}`
    }

    router.replace(redirectUrl)
  }, [path, reservation, router])
}

/**
 * 拠点日程選択ページで使われるリダイレクト処理
 */
export const useRedirectToLocationsReschedule = (
  reservation: Reservation | null,
  path: `trial_lessons/locations`
) => {
  const router = useRouter()

  useEffect(() => {
    if (!reservation) {
      return
    }

    const { locations_key } = router.query as {
      locations_key: LocationsKey
    }

    const currentParams = window.location.search
    const key = reservation.reservable.location?.key

    // 拠点日程選択 or オンラインの有効予約がある状態で拠点日程選択 -> 拠点振替ページに遷移する
    const redirectUrl = `/${path}/${locations_key || key}/${
      reservation.id
    }/reschedule${currentParams}`

    router.replace(redirectUrl)
  }, [path, reservation, router])
}

export const useRedirectToTop = () => {
  const router = useRouter()
  const { locations_key } = router.query as {
    locations_key: LocationsKey
  }

  useEffect(() => {
    if (!locations_key || !Object.values(LocationKey).includes(locations_key)) {
      router.replace('/trial_lessons')
    }
  }, [locations_key, router])
}
